<template>
    <div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">Host:</label>
            <div class="col-sm-9">
                <input v-model="value.Host" type="text" name="Host" class="form-control" />
            </div>
        </div>    
        <div class="form-group row">
            <label class="col-form-label col-sm-3">Port:</label>
            <div class="col-sm-9">
                <input v-model="value.Port" type="number" name="Port" class="form-control"  />
            </div>
        </div>    
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.username')}}:</label>
            <div class="col-sm-9">
                <input v-model="value.Username" type="text" name="UserName" class="form-control"  />
            </div>
        </div>    
        <div class="form-group row">
            <label class="col-form-label col-sm-3">{{translate('incomingDoc.password')}}:</label>
            <div class="col-sm-9">
                <input v-model="value.Password" type="password" name="Password" class="form-control"  />
            </div>
        </div>
        <!-- <div class="form-group row">
            <label class="col-form-label col-sm-3">Şifreleme Tipi:</label>
            <div class="col-sm-9">
                <select class="form-control" v-model="value.EncodingType" name="EncodingType">
                    <option value="option1">option 1</option>              
                    <option value="option2">option 2</option>              
                    <option value="option3">option 3</option>              
                </select>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-form-label col-sm-3">Alım Tipi:</label>
            <div class="col-sm-9">
                <select class="form-control"  v-model="value.RecipientType" name="RecipientType">
                    <option value="IMAP">IMAP</option>              
                    <option value="POP">POP</option>              
                </select>
            </div>
        </div> -->
    </div>
</template>

<script>

export default {
    components: {
    },
    props: ['value'],
    data(){
        return {

        }
    },
    methods: {
    }
}

</script>